var map = {
	"./blog.yml": 102,
	"./cloud.yml": 103,
	"./color.yml": 104,
	"./country.yml": 105,
	"./doc.yml": 106,
	"./emoji.yml": 107,
	"./flag.yml": 108,
	"./git.yml": 109,
	"./icon.yml": 110,
	"./license.yml": 111,
	"./link.yml": 112,
	"./metrics.yml": 113,
	"./people.yml": 114,
	"./soft.yml": 115,
	"./src.yml": 116,
	"./status.yml": 117,
	"./taxonomy.yml": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;